// extracted by mini-css-extract-plugin
module.exports = {"client":"clientoverlay_client__2t3IH","name":"clientoverlay_name__17bCE","button":"clientoverlay_button__x-rvy"};